// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CorrespondenceCopyScreen-module__button___ctNMI {
  height: 38px;
  margin: 14px;
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/components/screens/CorrespondenceCopyScreen/CorrespondenceCopyScreen.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,YAAA;AACF","sourcesContent":[".button {\n  height: 38px;\n  margin: 14px;\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `CorrespondenceCopyScreen-module__button___ctNMI`
};
module.exports = ___CSS_LOADER_EXPORT___;
